﻿import { createRoot } from 'react-dom/client';
import NavigationCore from "./NavigationCore";
import "./navigation.scss"

const htmlElement = document.getElementById("nav-app");

const root = createRoot(htmlElement as HTMLElement);

root.render(
    <NavigationCore
        apiUrl={htmlElement.dataset.apiurl}
        regionCode={htmlElement.dataset.regioncode} 
        activeArea={""}/>)